export const meetsPasswordMinLengthRequirement = (password: string) => password.length >= 8;
export const meetsPasswordMixedCasingRequirement = (password: string) => /(?=.*[a-z])(?=.*[A-Z])/.test(password);
export const meetsPasswordNonAlphaRequirement = (password: string) => /[^A-Za-z]/.test(password);
